export default {
  installTitle: 'Install the app?',
  installDescription: 'For quick access and offline access, the «Effective City» application can be installed on your device',
}